import './menu-burger.scss';
import './menu-main.scss';
import './menu-secondary.scss';
import './menu-navbar.scss';

jQuery(document).ready(function () {
  // Main menu

  jQuery('body').on('click focusin', function (event) {
    let container = jQuery('html').find('.menu-main');
    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(event.target) && container.has(event.target).length === 0) {
      container.find('li').removeClass('open');
    }
  });

  //Burger menu
  jQuery('#mb__icon').bind('click.burger', function (e) {
    let jQueryburgerButton = jQuery(this);
    let jQueryhtml = jQuery('html');

    if (jQueryburgerButton.hasClass('active')) {
      jQueryburgerButton.removeClass('active').removeAttr('aria-expanded');
      jQueryhtml.find('.menu-main').removeClass('active');
      jQueryhtml.removeClass('active-menu');
    } else {
      jQueryburgerButton.addClass('active').attr('aria-expanded', true);
      jQueryhtml.find('.menu-main').addClass('active');
      jQueryhtml.addClass('active-menu');
    }
  });
});
